import { DEFAULT_PAGE_INFO, SortInput } from '@apeiron/common'
import { DailyCheckInShop, DailyCheckInShopSortBy } from '@apeiron/reward'
import {
  deserializeListData,
  deserializePageInfo,
  PageInfo,
  PageInput,
  serializePagingInput
} from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { dailyCheckInShopSchema } from '@src/deserialize/yup/reward'
import graphql from '@src/graphql/query/getDailyCheckInShopItems'
import { useCallback, useState } from 'react'

const useGetDailyCheckInShopItems = (): Hook => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<DailyCheckInShop[]>([])

  const [pageInfo, setPageInfo] = useState<PageInfo>(DEFAULT_PAGE_INFO)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const {
        pageInput = {},
        sortInput = { sortBy: DailyCheckInShopSortBy.OrderSortByAsc }
      } = request

      const response = await query({
        variables: {
          input: {
            pagingInput: serializePagingInput(pageInput),
            sortInput
          }
        }
      })

      const dailyShop = deserializeListData<DailyCheckInShop>(
        response,
        dailyCheckInShopSchema
      )

      const pageInfo = deserializePageInfo(response, pageInput)

      setData(dailyShop)

      setPageInfo(pageInfo)

      return {
        data: dailyShop,
        pageInfo
      }
    },
    [query]
  )

  return {
    data,
    loading,
    pageInfo,
    fetch
  }
}

type Request = {
  pageInput?: PageInput
  sortInput?: SortInput<DailyCheckInShopSortBy>
}

type Response = {
  data: DailyCheckInShop[]
  pageInfo: PageInfo
}

type Hook = {
  data: DailyCheckInShop[]
  fetch: (request: Request) => Promise<Response>
  loading: boolean
  pageInfo: PageInfo
}

export default useGetDailyCheckInShopItems
